import { render, staticRenderFns } from "./WelcomeSigns.vue?vue&type=template&id=03d1c6e1"
import script from "./WelcomeSigns.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeSigns.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports